import type { QuestionType } from '../../lib/votings';
import { Box } from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  type: QuestionType;
  size?: number;
  /** Farba ťahu. Predvolene sekundárny text; vybraný typ ho má červený. */
  color?: string;
};

/**
 * Ikona typu otázky - jediná vec, podľa ktorej sa typ pozná bez čítania.
 *
 * Sú to kreslené `path`-y, nie ikony z `@mui/icons-material`: dve z nich
 * (prepínač, zaškrtávacie pole) musia vyzerať presne ako ovládacie prvky, ktoré
 * občan uvidí v hlasovaní, a MUI ikony `RadioButtonChecked`/`CheckBox` sú plné
 * plochy s iným polomerom. Rozdiel medzi „jedna možnosť" a „viac možností" je
 * tvar toho prvku, takže musí sedieť.
 */
const QuestionTypeIcon: React.FC<Props> = ({ type, size = 16, color }) => {
  const stroke = color ?? 'currentColor';

  return (
    <Box
      component='svg'
      viewBox='0 0 24 24'
      width={size}
      height={size}
      fill='none'
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden
      sx={{ display: 'block', flex: 'none' }}
    >
      {type === 'single_choice' && (
        <>
          <circle cx='12' cy='12' r='8' />
          <circle cx='12' cy='12' r='3.4' fill={stroke} stroke='none' />
        </>
      )}
      {type === 'multi_choice' && (
        <>
          <rect x='4' y='4' width='16' height='16' rx='3' />
          <path d='M8 12.5l2.6 2.6L16 9.6' />
        </>
      )}
      {type === 'free_text' && <path d='M4 7h16M4 12h16M4 17h9' />}
      {type === 'scale' && <path d='M4 18V9M9 18V5M14 18v-6M19 18v-9' />}
    </Box>
  );
};

export default QuestionTypeIcon;
